import {createStore, applyMiddleware, combineReducers} from 'redux';
import thunk from 'redux-thunk';

export default function configureStore(initialState) {
    return createStore(
        combineReducers({
            status,
            systems,
            incidents,
            generalContent,
            itemsHasErrored,
            itemsIsLoading
        }),
        initialState,
        applyMiddleware(thunk)
    );
}

export function itemsHasErrored(state = false, action) {
    switch (action.type) {
        case 'ITEMS_HAS_ERRORED':
            return action.hasErrored;

        default:
            return state;
    }
}

export function itemsIsLoading(state = false, action) {
    switch (action.type) {
        case 'ITEMS_IS_LOADING':
            return action.isLoading;

        default:
            return state;
    }
}

export function status(state = [], action) {
    switch (action.type) {
        case 'STATUS_SUCCESS':
            return action.status;

        default:
            return state;
    }
}

export function systems(state = [], action) {
    switch (action.type) {
        case 'SYSTEM_SUCCESS':
            return action.systems;

        default:
            return state;
    }
}
export function incidents(state = [], action) {
    switch (action.type) {
        case 'INCIDENTS_SUCCESS':
            return action.incidents;

        default:
            return state;
    }
}

export function generalContent(state = [], action) {
    switch (action.type) {
        case 'GENERAL_CONTENT_SUCCESS':
            return action.generalContent;

        default:
            return state;
    }
}





// WEBPACK FOOTER //
// ./src/Redux/ConfigureReduxStore.js